import LinkedinCallback from "./LinkedinCallback";

export default LinkedinCallback;
